import randomHash from '../../../procedures/external/random-hash';

export default ({ action, filename }) => new Promise((resolve, reject) => {
  action
    .then(({ data }) => {
      const url = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || randomHash();
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      resolve();
    })
    .catch(error => {
      reject(error);
    });
});